import(/* webpackMode: "eager" */ "/app/src/app/privacy-and-terms/terms/page.tsx");
